export default {"src":"https://s.sylndr.com/c-17ada32/_next/static/media/freeIcon.4c8cd964.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};